/**
 * User lifecycle statuses.
 * Source of truth — keep in sync with backend enum `UserStatus`.
 *
 * Transitions are gated server-side; frontend only displays the status.
 * The terminal `deleted` state requires a separate confirm step (see UserResource).
 */
export type UserStatus = 'invited' | 'active' | 'inactive' | 'deleted'

export const USER_STATUS_MAP: Record<UserStatus, { label: string; color: string }> = {
    invited: { label: 'Запрошений', color: '#4a9eff' },
    active: { label: 'Активний', color: '#52c41a' },
    inactive: { label: 'Деактивований', color: '#ff4d4f' },
    deleted: { label: 'Видалений', color: '#595959' },
}

/**
 * Antd-compatible options array — derived from USER_STATUS_MAP.
 * Used as `options` for `type: 'status'` field in UserResource.
 */
export const USER_STATUS_OPTIONS = (Object.entries(USER_STATUS_MAP) as Array<[UserStatus, { label: string; color: string }]>)
    .map(([value, info]) => ({ value, label: info.label, color: info.color }))
